'use client'

import { Link } from '@react-email/components'
import posthog from 'posthog-js'
import { useEffect } from 'react'
import { Button, buttonVariants } from '@/components/ui/button'

export default function ErrorPage({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    posthog.captureException(error)
  }, [error])

  return (
    <div className="flex grow flex-col items-center justify-center gap-12 p-4">
      <span className="select-none bg-gradient-to-b from-foreground/20 to-foreground/5 bg-clip-text font-black text-9xl text-transparent blur-sm dark:from-foreground/15 dark:to-foreground/0">
        500
      </span>

      <main className="flex flex-col items-center gap-2">
        <h1 className="font-bold text-3xl tracking-tight">Something went wrong!</h1>
        <p className="max-w-[25rem] text-center text-muted-foreground">
          We've logged this error and will look into it.
        </p>
      </main>

      <nav className="flex items-center gap-4">
        <Link className={buttonVariants({ variant: 'outline' })} href="/app">
          Back to App
          {/* <GridIcon /> */}
        </Link>
        <Button variant="outline" onClick={() => reset()}>
          Try again
        </Button>
      </nav>
    </div>
  )
}
